module.exports = __webpack_public_path__ + "img/eg-18-01.20faf1b3.jpg";